import { Language } from './i18n';

export async function updateMetaTags(language: Language) {
  try {
    const response = await fetch(`/content/translations/${language}.json`);
    if (!response.ok) {
      throw new Error('Failed to load translations');
    }
    const translations = await response.json();
    const meta = translations.meta;

    // Get the appropriate meta image based on language
    const metaImage = `/images/metatag_img_${language}.PNG`;

    // Update title and description
    document.title = meta.title;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', meta.description);
    }

    // Update language metadata
    document.documentElement.lang = language;
    const metaLanguage = document.querySelector('meta[name="language"]');
    if (metaLanguage) {
      metaLanguage.setAttribute('content', language);
    }
    const metaContentLanguage = document.querySelector('meta[http-equiv="content-language"]');
    if (metaContentLanguage) {
      metaContentLanguage.setAttribute('content', language);
    }

    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', meta.og.title);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', meta.og.description);
    }

    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) {
      ogImage.setAttribute('content', metaImage);
    }

    const ogSiteName = document.querySelector('meta[property="og:site_name"]');
    if (ogSiteName) {
      ogSiteName.setAttribute('content', meta.og.site_name);
    }

    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale) {
      ogLocale.setAttribute('content', meta.og.locale);
    }

    const ogLocaleAlternate = document.querySelector('meta[property="og:locale:alternate"]');
    if (ogLocaleAlternate) {
      ogLocaleAlternate.setAttribute('content', language === 'ja' ? 'de_DE' : 'ja_JP');
    }

    // Update Twitter Card tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', meta.og.title);
    }

    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', meta.og.description);
    }

    const twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (twitterImage) {
      twitterImage.setAttribute('content', metaImage);
    }

    // Update Organization Schema
    const organizationSchema = document.getElementById('organizationSchema');
    if (organizationSchema) {
      organizationSchema.textContent = JSON.stringify(translations.structuredData.organization);
    }
  } catch (error) {
    console.error('Error updating meta tags:', error);
  }
}